import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { Component } from 'react';
import { MdOutlineMarkEmailRead } from 'react-icons/md';

export default class ApuracaoEmailSucessoDialog extends Component {
    render() {
        let { onClose } = this.props;

        return (
            <Dialog 
                open={true}
                onClose={onClose} 
                fullWidth 
                maxWidth="xs"
            >
                <DialogTitle sx={{ textAlign: 'center', pt: 3, pb: 1 }}>
                    <MdOutlineMarkEmailRead size={64} color="#2e7d32" />
                </DialogTitle>
                <DialogContent>
                    <Stack gap={1} alignItems="center" textAlign="center">
                        <Typography variant="h6" fontWeight="bold">
                            E-mail enviado com sucesso!
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Sua mensagem foi entregue aos destinatários selecionados.
                        </Typography>
                    </Stack>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center', pb: 3, px: 3 }}>
                    <Button 
                        onClick={onClose} 
                        variant="contained" 
                        disableElevation
                        fullWidth
                        sx={{ bgcolor: '#2e7d32', '&:hover': { bgcolor: '#1b5e20' } }}
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}